(function () {
  function parsePrizes(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && String(item.variant_id || '').trim() !== '';
      }) : [];
    } catch (error) {
      console.warn('Loot Box Game JSON parse failed', error);
      return [];
    }
  }

  function weightedPick(prizes, excludedId) {
    var pool = prizes.filter(function (item) {
      return !excludedId || item.id !== excludedId;
    });

    if (!pool.length) {
      pool = prizes.slice();
    }

    var total = pool.reduce(function (sum, item) {
      return sum + Math.max(1, Number(item.weight || 1));
    }, 0);

    if (!total) {
      return pool[0] || null;
    }

    var threshold = Math.random() * total;
    var running = 0;

    for (var i = 0; i < pool.length; i += 1) {
      running += Math.max(1, Number(pool[i].weight || 1));
      if (threshold <= running) {
        return pool[i];
      }
    }

    return pool[pool.length - 1] || null;
  }

  function moneySafe(value) {
    return String(value == null ? '' : value);
  }

  function prizeMarkup(prize) {
    var badge = prize.badge ? '<span class="lbg-prize-card__badge">' + escapeHtml(prize.badge) + '</span>' : '';
    var image = prize.image ? '<div class="lbg-prize-card__image"><img src="' + escapeAttribute(prize.image) + '" alt="' + escapeAttribute(prize.title || 'Prize') + '"></div>' : '<div class="lbg-prize-card__image lbg-prize-card__image--empty"></div>';

    return (
      '<div class="lbg-prize-card lbg-prize-card--mini">' +
        image +
        '<div class="lbg-prize-card__content">' +
          badge +
          '<h4 class="lbg-prize-card__title">' + escapeHtml(prize.title || 'Prize') + '</h4>' +
          '<p class="lbg-prize-card__copy">' + escapeHtml(prize.caption || '') + '</p>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function refreshCartAfterBonus(openMiniCart) {
    return fetch(window.themeVariables.routes.cartUrl + '.js')
      .then(function (response) { return response.json(); })
      .then(function (cartContent) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: openMiniCart
          }
        }));
      });
  }

  function createHiddenInput(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-lbg-hidden', 'true');
    form.appendChild(input);
  }

  function updateCardTargets(scope, prefix, prize) {
    var imageWrap = scope.querySelector('[data-lbg-' + prefix + '-image]');
    var badge = scope.querySelector('[data-lbg-' + prefix + '-badge]');
    var title = scope.querySelector('[data-lbg-' + prefix + '-title]');
    var copy = scope.querySelector('[data-lbg-' + prefix + '-copy]');

    if (imageWrap) {
      imageWrap.innerHTML = prize.image ? '<img src="' + escapeAttribute(prize.image) + '" alt="' + escapeAttribute(prize.title || 'Prize') + '">' : '';
      imageWrap.classList.toggle('is-empty', !prize.image);
    }

    if (badge) {
      badge.textContent = prize.badge || '';
      badge.hidden = !prize.badge;
    }

    if (title) {
      title.textContent = prize.title || '';
    }

    if (copy) {
      copy.textContent = prize.caption || '';
    }
  }

  function showState(scope, stateName) {
    scope.querySelectorAll('.lbg-state').forEach(function (node) {
      node.hidden = !node.hasAttribute('data-lbg-' + stateName);
    });
  }

  function initLootBoxGame(scope) {
    if (!scope || scope.__lbgReady) return;
    scope.__lbgReady = true;

    var prizes = parsePrizes(scope.getAttribute('data-prizes'));
    if (!prizes.length) return;

    var productId = scope.getAttribute('data-product-id');
    var productTitle = scope.getAttribute('data-product-title') || '';
    var campaignLabel = scope.getAttribute('data-campaign-label') || 'Loot Box Campaign';
    var bonusLabel = scope.getAttribute('data-bonus-label') || 'Loot Box Prize';
    var claimLabel = scope.getAttribute('data-claim-label') || 'Promo Bonus';
    var boxes = Array.prototype.slice.call(scope.querySelectorAll('[data-lbg-box]'));
    var keepButton = scope.querySelector('[data-lbg-keep]');
    var rerollButton = scope.querySelector('[data-lbg-reroll]');
    var chooseOriginalButton = scope.querySelector('[data-lbg-choose-original]');
    var chooseNewButton = scope.querySelector('[data-lbg-choose-new]');
    var originalChoice = scope.querySelector('[data-lbg-original-choice]');
    var newChoice = scope.querySelector('[data-lbg-new-choice]');
    var form = document.querySelector('form[is="product-form"]');
    var storageKey = 'lbg:' + productId;
    var state = {
      selectedBox: null,
      firstPrize: null,
      rerollPrize: null,
      finalPrize: null,
      hasRerolled: false,
      animating: false,
      bonusSyncInFlight: false
    };

    function syncFormProperties() {
      if (!form) return;

      form.querySelectorAll('[data-lbg-hidden="true"]').forEach(function (node) {
        node.remove();
      });

      if (!state.finalPrize) return;

      createHiddenInput(form, 'properties[' + bonusLabel + ']', state.finalPrize.title || 'Prize');
      createHiddenInput(form, 'properties[Loot Box Campaign]', campaignLabel);
      createHiddenInput(form, 'properties[Loot Box Prize Variant ID]', String(state.finalPrize.variant_id || ''));
      createHiddenInput(form, 'properties[Loot Box Selection Method]', state.hasRerolled ? 'Kept after reroll' : 'Kept first reveal');
    }

    function persist() {
      var payload = {
        selectedBox: state.selectedBox,
        firstPrize: state.firstPrize,
        rerollPrize: state.rerollPrize,
        finalPrize: state.finalPrize,
        hasRerolled: state.hasRerolled
      };

      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
      } catch (error) {
        console.warn('Loot Box Game storage failed', error);
      }
    }

    function restore() {
      try {
        var raw = window.sessionStorage.getItem(storageKey);
        if (!raw) return;
        var saved = JSON.parse(raw);
        state.selectedBox = saved.selectedBox || null;
        state.firstPrize = saved.firstPrize || null;
        state.rerollPrize = saved.rerollPrize || null;
        state.finalPrize = saved.finalPrize || null;
        state.hasRerolled = !!saved.hasRerolled;
      } catch (error) {
        console.warn('Loot Box Game restore failed', error);
      }
    }

    function updateBoxClasses() {
      boxes.forEach(function (box) {
        var isSelected = String(box.getAttribute('data-box-index')) === String(state.selectedBox);
        box.classList.toggle('is-selected', isSelected);
        box.classList.toggle('is-locked', !!state.finalPrize);
      });
    }

    function render() {
      updateBoxClasses();

      if (state.finalPrize) {
        updateCardTargets(scope, 'final', state.finalPrize);
        syncFormProperties();
        showState(scope, 'confirmed');
        return;
      }

      if (state.rerollPrize && state.firstPrize) {
        if (originalChoice) originalChoice.innerHTML = prizeMarkup(state.firstPrize);
        if (newChoice) newChoice.innerHTML = prizeMarkup(state.rerollPrize);
        showState(scope, 'compare');
        return;
      }

      if (state.firstPrize) {
        updateCardTargets(scope, 'first', state.firstPrize);
        showState(scope, 'first');
        return;
      }

      showState(scope, 'idle');
    }

    function revealPrize(selectedBox) {
      if (state.animating || state.finalPrize) return;

      state.animating = true;
      state.selectedBox = selectedBox;
      updateBoxClasses();
      showState(scope, 'loading');

      window.setTimeout(function () {
        state.firstPrize = weightedPick(prizes, null);
        state.animating = false;
        persist();
        render();
      }, 950);
    }

    function rerollPrize() {
      if (!state.firstPrize || state.animating || state.hasRerolled) return;

      state.animating = true;
      state.hasRerolled = true;
      showState(scope, 'loading');

      window.setTimeout(function () {
        state.rerollPrize = weightedPick(prizes, state.firstPrize.id);
        state.animating = false;
        persist();
        render();
      }, 950);
    }

    function lockPrize(prize) {
      state.finalPrize = prize;
      persist();
      render();
    }

    function addBonusItem(mainVariant) {
      if (!state.finalPrize || !state.finalPrize.variant_id || !form || state.bonusSyncInFlight) {
        return;
      }

      state.bonusSyncInFlight = true;

      var quantityField = form.querySelector('[name="quantity"]');
      var quantity = quantityField ? Math.max(1, parseInt(quantityField.value || '1', 10)) : 1;
      var payload = {
        items: [
          {
            id: Number(state.finalPrize.variant_id),
            quantity: quantity,
            properties: {}
          }
        ]
      };

      payload.items[0].properties[claimLabel] = state.finalPrize.title || 'Prize';
      payload.items[0].properties['Loot Box Campaign'] = campaignLabel;
      payload.items[0].properties['Linked PC'] = productTitle;
      payload.items[0].properties['Linked PC Variant ID'] = moneySafe(mainVariant && mainVariant.id ? mainVariant.id : '');
      payload.items[0].properties['Loot Box Final Choice'] = state.hasRerolled ? 'Chosen after reroll' : 'Kept first reveal';

      fetch(window.themeVariables.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.ok ? response.json() : response.json().then(function (json) { throw json; });
        })
        .then(function () {
          var openMiniCart = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer';
          return refreshCartAfterBonus(openMiniCart);
        })
        .catch(function (error) {
          document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: {
              status: 'error',
              error: error && error.description ? error.description : 'The loot box bonus could not be added automatically.'
            }
          }));
        })
        .finally(function () {
          state.bonusSyncInFlight = false;
        });
    }

    boxes.forEach(function (box) {
      box.addEventListener('click', function () {
        if (state.firstPrize || state.finalPrize || state.animating) return;
        revealPrize(box.getAttribute('data-box-index'));
      });
    });

    if (keepButton) {
      keepButton.addEventListener('click', function () {
        if (state.firstPrize) {
          lockPrize(state.firstPrize);
        }
      });
    }

    if (rerollButton) {
      rerollButton.addEventListener('click', function () {
        rerollPrize();
      });
    }

    if (chooseOriginalButton) {
      chooseOriginalButton.addEventListener('click', function () {
        if (state.firstPrize) {
          lockPrize(state.firstPrize);
        }
      });
    }

    if (chooseNewButton) {
      chooseNewButton.addEventListener('click', function () {
        if (state.rerollPrize) {
          lockPrize(state.rerollPrize);
        }
      });
    }

    if (form) {
      form.addEventListener('variant:added', function (event) {
        addBonusItem(event.detail && event.detail.variant ? event.detail.variant : null);
      });
    }

    restore();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-lbg-section]').forEach(initLootBoxGame);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
